export default class CookieHelpers {
    static getCookie(cname: string): string {
      const name = cname + '=';
      const decodedCookie = decodeURIComponent(document.cookie);
      const ca = decodedCookie.split(';');
  
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
  
      return '';
    }
  
    static setCookie(
      cname: string,
      cvalue: string,
      exdays = 999,
      secure = true,
      samesite = 'strict',
    ) {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      const expires = 'expires=' + d.toUTCString();
  
      // browser can't set secure cookie on a non-secure site
      // no cookies will be set if not handled
      if (!location.protocol.includes('https')) {
        secure = false;
      }
  
      document.cookie = `${cname}=${cvalue};${expires};path=/${
        secure ? ';secure' : ''
      }${samesite ? `;samesite=${samesite}` : ''}`;
    }
  }  